import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import {
    getReactSelectStyling,
    getReactSelectTheme,
} from "../../utils/ReactSelectStyles";

const FilterHistoryDropdown = ({
    recentFiltersLoading,
    recentFilters,
    recentFilter,
    setRecentFilter,
    applyRecentFilter,
}) => {
    const { t } = useTranslation();
    const history = useHistory();

    const applyFilter = async (row) => {
        await setRecentFilter(row);
        if (row) applyRecentFilter(row);
    };

    return (
        <div className="input-group">
            <label className="uppercase">{t("recentlyUsedFilters")}</label>
            <div className="flex gap-2 mb-5">
                <Select
                    isClearable
                    isSearchable
                    name="recentFilters"
                    onChange={(row) => applyFilter(row)}
                    options={recentFilters}
                    getOptionValue={(option) =>
                        option.searchable || option.value
                    }
                    value={recentFilter || ""}
                    styles={getReactSelectStyling({
                        valueContainerStyle: true,
                    })}
                    theme={getReactSelectTheme}
                    placeholder={t("selectRecentlyUsedFilters")}
                    isLoading={recentFiltersLoading}
                    className="flex-1"
                />
                <div className="main-customer-form-bnt flex items-center justify-end">
                    <button
                        className="secondary-green-btn mng-model modal-btn-open ml-2"
                        onClick={() => history.push("/scans/filters")}
                    >
                        <i className="fas fa-cog mr-2"></i>
                        {t("manageFilters")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FilterHistoryDropdown;
